import simpleParallax from "simple-parallax-js/vanilla";

export default {
  mounted(el, binding) {
    el.parallax = new simpleParallax(el, {
      ...binding.value,
    });
  },
  unmounted(el) {
    if (el.parallax) {
      el.parallax.destroy();
    }
  }
};